import Rating from '@/shared/components/Rating/Rating'
import styles from './FeedbackSummary.module.scss'

function FeedbackSummary() {
  return (
    <div className={`${styles.feedbackSummaryWrapper}`}>
      <div className={styles.feedbackSummaryList}>
        <div className={styles.feedbackSummaryItem}>
          <p className={`${styles.feedbackSummaryItemLabel} title-medium`}>
            Food and Drinks:
          </p>
          <div className={styles.ratingContainer}>
            <Rating defaultValue={4.9} isReadOnly />
            <p className={`${styles.feedbackSummaryItemValue} title-medium`}>
              4.9 / 5
            </p>
          </div>
        </div>
        <div className={styles.feedbackSummaryItem}>
          <p className={`${styles.feedbackSummaryItemLabel} title-medium`}>
            Service:
          </p>
          <div className={styles.ratingContainer}>
            <Rating defaultValue={3.2} isReadOnly />
            <p className={`${styles.feedbackSummaryItemValue} title-medium`}>
              3.2 / 5
            </p>
          </div>
        </div>
        <div className={styles.feedbackSummaryItem}>
          <p className={`${styles.feedbackSummaryItemLabel} title-medium`}>
            Ambiance:
          </p>
          <div className={styles.ratingContainer}>
            <Rating defaultValue={4.5} isReadOnly />
            <p className={`${styles.feedbackSummaryItemValue} title-medium`}>
              4.5 / 5
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeedbackSummary
